export default __webpack_public_path__ + "static/media/water-background.208a25e1.jpg";